<app-page
  title="Payments"
  [isLoading]="(patientBalanceState$ | async)?.isLoading || (paymentMethodsState$ | async)?.isLoading"
  [error]="(patientBalanceState$ | async)?.error || (paymentMethodsState$ | async)?.error"
>
  <p-card styleClass="card-min-h" data-cy="payments-container">
    <h2 class="mt-0 mb-0">Current Balance</h2>
    <h1 class="mt-3">{{ (patientBalanceState$ | async)?.data?.balance | formatCurrency }}</h1>
    <p-divider></p-divider>
    <app-message *ngIf="makePaymentError" severity="error" [noMargin]="false" data-cy="make-payment-error-message">
      {{ makePaymentError }}
    </app-message>
    <form [formGroup]="makePaymentForm" (ngSubmit)="onSubmit()" data-cy="payment-amount-form">
      <h3 class="mt-0 mb-3">Payment Amount</h3>
      <app-form-field
        [control]="asFormControl(makePaymentForm.get('paymentAmount'))"
        name="paymentAmount"
        label="Enter Amount"
        errorLabel="Amount"
        type="input"
        [limitWidth]="true"
        inputType="number"
        inputMode="currency"
      >
      </app-form-field>
      <p-divider></p-divider>
      <h3 class="mt-2">Payment Method</h3>
      <small
        *ngIf="
          asFormControl(makePaymentForm.get('paymentMethodId')).hasError('required') &&
          (asFormControl(makePaymentForm.get('paymentMethodId')).dirty ||
            asFormControl(makePaymentForm.get('paymentMethodId')).touched)
        "
        class="p-error block"
        data-cy="error-required"
        >Please select a payment method</small
      >
      <div class="w-12 md:w-10 lg:w-8 xl:w-6">
        <app-payment-method-radio
          [control]="asFormControl(makePaymentForm.get('paymentMethodId'))"
          name="paymentMethodId"
        ></app-payment-method-radio>
      </div>
      <button
        pButton
        type="button"
        label="Add new payment method"
        icon="mi-round mi-add-circle-outline"
        class="p-button-text p-button-sm my-4"
        (click)="showNewPaymentMethodModal()"
        data-cy="add-new-payment-method-button"
        appClickEvent
        eventName="payments_add_payment_method"
      ></button>
      <app-form-footer submitLabel="Submit" [noCancel]="true" [justifyLeft]="true"> </app-form-footer>
    </form>
    <app-payment-method-form
      [(visible)]="displayNewPaymentMethodModal"
      (submitForm)="onPaymentMethodCreated($event)"
    ></app-payment-method-form>
  </p-card>
</app-page>
<app-confirmation-modal
  [(visible)]="displayPaymentConfirmationModal"
  title="Confirm Payment"
  [disabled]="(makePaymentState$ | async)?.isLoading"
  [message]="getConfirmationMessage()"
  [submitLabel]="(makePaymentState$ | async)?.isLoading ? 'Submitting Payment...' : 'Confirm'"
  cancelLabel="Cancel"
  (confirmAction)="onConfirm()"
  (cancelAction)="onCancel()"
  data-cy="payment-confirmation-modal"
>
</app-confirmation-modal>
<app-notification-overlay
  [(visible)]="displayNotificationOverlay"
  title="Payment Success!"
  message="Thank you for your payment!"
  type="success"
  (dismiss)="onNotificationDismissed()"
></app-notification-overlay>
